document.addEventListener("DOMContentLoaded", function () {

    const slider = document.querySelector(".testimonial-slider");
  
    if (!slider) return;
  
    const swiper = new Swiper(slider, {
  
      slidesPerView: 1.28,
      spaceBetween: 12,
      speed: 4000, // Speed for continuous movement
      grabCursor: true,
      watchOverflow: true,

      /* --- Continuous Infinite Loop --- */
      loop: true,
      autoplay: {
        delay: 0, // Zero delay for smooth continuous motion
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
  
      pagination: {
        el: ".testimonial-slider .swiper-pagination",
        clickable: true,
      },
  
      navigation: {
        nextEl: ".testimonial-slider .swiper-button-next",
        prevEl: ".testimonial-slider .swiper-button-prev",
      },
  
      breakpoints: {
        480: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 16,
        }
      }
    });

    /* CSS Fix for continuous linear motion */
    const wrapper = slider.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.style.transitionTimingFunction = 'linear';
    }
  
    /*-----------------------------
        Video Play / Pause Logic
    ------------------------------*/
    document.querySelectorAll(".testimonial-video-card").forEach(function(card){
        const btn = card.querySelector(".video-play-btn");
        const video = card.querySelector("video");
  
        if(!video || !btn) return;

        function playVideo() {
            document.querySelectorAll(".testimonial-video-card video").forEach(function(v){
                if(v !== video){
                    v.pause();
                    const b = v.closest(".testimonial-video-card").querySelector(".video-play-btn");
                    if(b) b.style.display = "flex";
                }
            });

            video.play();
            btn.style.display = "none";

            if (swiper.autoplay) {
                swiper.autoplay.stop();
            }
        }

        function pauseVideo() {
            video.pause();
            btn.style.display = "flex";

            if (swiper.autoplay) {
                swiper.autoplay.start();
            }
        }
  
        btn.addEventListener("click", function(){
            if(video.paused){
                playVideo();
            } else {
                pauseVideo();
            }
        });
  
        video.addEventListener("click", function(){
            if(video.paused){
                playVideo();
            } else {
                pauseVideo();
            }
        });
  
        video.addEventListener("ended", function(){
            btn.style.display = "flex";
            if (swiper.autoplay) {
                swiper.autoplay.start();
            }
        });
    });
  
});